import {SubAPI} from "./SubAPI";

export class CompanySettings extends SubAPI {
    get() {
        return this.fetcher.get<CompanySetting>("/api/company-setting", {});
    }

    upsert(props: CompanySetting) {
        return this.fetcher.post<CompanySetting>("/api/company-setting", props);
    }
}

export type CompanySetting = {
    defaultFrameAnchorProduct: number | null;
    defaultFrameAnchorProductName?: string | null;
};
